import { useQuery } from "@apollo/client";
import { GetDentistListDocument } from "../../gql/generated/graphql";

export const useDentistList = () => {
  const { data, loading } = useQuery(GetDentistListDocument, {
    variables: {
      where: {
        role: {
          equals: "USER",
        },
        type: {
          equals: "DENTIST",
        },
      },
    },
  });

  return {
    dentistList: data?.users ?? [],
    isLoading: loading,
  };
};
